export default {
  CHALLENGES: { slug: '/challenges', friendlyName: 'Challenges' },
  SCOREBOARD: { slug: '/scoreboard', friendlyName: 'Scoreboard' },
};
